import React from "react";

export const ArrowSvgAnime = () => {
  return (
    <>
      <svg
        width="94"
        height="72"
        viewBox="0 0 124 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 47.1304L35.7978 88.0594C37.2825 90.0988 40.2612 90.2714 41.9716 88.4173L118 6"
          stroke="#0B68B5"
          strokeWidth="12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
